import { Button } from "@patient-watch/ui";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useCopy } from "../i18n/locale";

interface FormButtonsProps {
    submitting: boolean;
    submitLabel?: string;
    showPrevious?: boolean;
    onPrevious?: () => void;
}

export default function FormButtons({ submitting, submitLabel, showPrevious = true, onPrevious }: FormButtonsProps) {
    const copy = useCopy().common;
    const label = submitLabel ?? copy.next;
    return (
        <div className="flex justify-between gap-2 pt-6">
            {showPrevious && (
                <Button type="button" variant="outline" onClick={onPrevious}>
                    <ChevronLeft size={20} /> {copy.previous}
                </Button>
            )}
            <Button type="submit" disabled={submitting}>
                {submitting ? copy.saving : label}
                {!submitting && <ChevronRight size={20} />}
            </Button>
        </div>
    );
}
